export default function UserIcon({ width="15px", stroke="#667085" }) {
  return (
    <svg
      width={width}
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0304 14.9697V13.4546C13.0304 12.6509 12.7111 11.8801 12.1428 11.3118C11.5745 10.7435 10.8038 10.4243 10.0001 10.4243H4.69705C3.89336 10.4243 3.1226 10.7435 2.5543 11.3118C1.98601 11.8801 1.66675 12.6509 1.66675 13.4546V14.9697M16.0607 5.12122V9.66668M18.3334 7.39395H13.788M10.3789 4.36365C10.3789 6.03724 9.02216 7.39395 7.34857 7.39395C5.67498 7.39395 4.31826 6.03724 4.31826 4.36365C4.31826 2.69006 5.67498 1.33334 7.34857 1.33334C9.02216 1.33334 10.3789 2.69006 10.3789 4.36365Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
